// removed by extract-text-webpack-plugin
module.exports = {"tiny":"380px","mobile":"768px","medium":"769px","large":"1013px"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/sponsorship/SponsorshipHowItWorks.scss
// module id = 1256
// module chunks = 0